import React, { Component } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { requiredField, isNull } from "../../../common/helper";

class EntityBeneficiaryEditForm extends Component {
  constructor(props) {
    super(props);
    const b = this.props.beneficiary;
    this.state = {
      beneficiary: {
        id: b.id,
        name: b.name || "",
        friendly_name: b.friendly_name || "",
        client_reference_beneficiary: b.client_reference_beneficiary || "",
        recipient_reference_beneficiary: b.recipient_reference_beneficiary || "",
        beneficiary_email: b.beneficiary_email || "",
        beneficiary_cell: b.beneficiary_cell || "",
        beneficiary_address: b.beneficiary_address || "",
        bank_name: b.bank_name || "",
        bank_address: b.bank_address || "",
        bank_country: b.bank_country || "",
        bank_branch_code: b.bank_branch_code || "",
        swift_or_bic: b.swift_or_bic || "",
        beneficiary_account_number: b.beneficiary_account_number || "",
        currency: b.currency || "",
        notify_sms: b.notify_sms || false,
        notify_email: b.notify_email || false,
        swift_fees_instructions: b.swift_fees_instructions || "",
        crypto: b.crypto || false,
      },
      errorArray: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handlePopChange = this.handlePopChange.bind(this);
  }

  componentDidMount() {
    this.setState((st) => ({
      beneficiary: { ...st.beneficiary, entity_id: this.props.client.entity },
    }));
  }

  handleChange(evt) {
    this.setState((st) => ({
      beneficiary: {
        ...st.beneficiary,
        [evt.target.name]: evt.target.value,
      },
    }));
  }

  handlePopChange(evt) {
    const val = evt.target.value;
    this.setState((st) => {
      let notify_email = false;
      let notify_sms = false;
      switch (val) {
        case "Email":
          notify_email = true;
          break;
        case "SMS":
          notify_sms = true;
          break;
        case "Email & SMS":
          notify_email = true;
          notify_sms = true;
          break;
        default:
          break;
      }
      return {
        beneficiary: {
          ...st.beneficiary,
          notify_email,
          notify_sms,
        },
      };
    });
  }

  getPopValue() {
    const { notify_email, notify_sms } = this.state.beneficiary;
    if (notify_email && notify_sms) return "Email & SMS";
    if (notify_email) return "Email";
    if (notify_sms) return "SMS";
    return "";
  }

  formValidation() {
    const requiredFields = ["name", "friendly_name"];
    this.setState({
      errorArray: requiredFields.map((key) =>
        requiredField(this.state.beneficiary[key], key)
      ),
    });
  }

  render() {
    const { beneficiary } = this.state;
    const { currencies = [], countries = [] } = this.props;

    return (
      <>
        <Modal
          show={this.props.isShown}
          animation={false}
          size="lg"
          onHide={() => this.props.back()}
        >
          <Modal.Header>
            <div>
              <span className="text-muted small text-uppercase fw-semibold" style={{ letterSpacing: "0.05em" }}>
                Editing beneficiary for
              </span>
              <Modal.Title className="mt-1">
                {this.props.client?.firstname} {this.props.client?.surname}
              </Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row">

              <div className="col-12 mb-2">
                <h6 className="text-muted text-uppercase small fw-bold border-bottom pb-1">
                  Beneficiary Details
                </h6>
              </div>

              <div className="col-12">
                <label className="form-label">Beneficiary Full Name*</label>
                <InputGroup className="mb-3">
                  <FormControl
                    name="name"
                    placeholder="Beneficiary Full Name"
                    value={beneficiary.name}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </div>

              <div className="col-12">
                <label className="form-label">Friendly Name*</label>
                <InputGroup className="mb-3">
                  <FormControl
                    name="friendly_name"
                    placeholder="Friendly Name"
                    value={beneficiary.friendly_name}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </div>

              {/* <div className="col-6">
                <label className="form-label">Client Reference*</label>
                <InputGroup className="mb-3">
                  <FormControl
                    name="client_reference_beneficiary"
                    placeholder="Client Reference"
                    value={beneficiary.client_reference_beneficiary}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </div> */}

              {/* <div className="col-6">
                <label className="form-label">Recipient Reference</label>
                <InputGroup className="mb-3">
                  <FormControl
                    name="recipient_reference_beneficiary"
                    placeholder="Recipient Reference"
                    value={beneficiary.recipient_reference_beneficiary}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </div> */}

              <div className="col-12">
                <label className="form-label">Beneficiary Address</label>
                <InputGroup className="mb-3">
                  <FormControl
                    name="beneficiary_address"
                    placeholder="Beneficiary Address"
                    as="textarea"
                    rows={2}
                    value={beneficiary.beneficiary_address}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </div>

              <div className="col-12 mb-2 mt-2">
                <h6 className="text-muted text-uppercase small fw-bold border-bottom pb-1">
                  Proof of Payment
                </h6>
              </div>

              <div className="col-6">
                <label className="form-label">Proof of Payment</label>
                <Form.Control
                  as="select"
                  className="mb-3"
                  value={this.getPopValue()}
                  onChange={this.handlePopChange}
                >
                  <option value="">Select a POP method</option>
                  <option value="Email">Email</option>
                  <option value="SMS">SMS</option>
                  <option value="Email & SMS">Email &amp; SMS</option>
                </Form.Control>
              </div>

              {(beneficiary.notify_email || beneficiary.notify_sms) && (
                <>
                  {beneficiary.notify_email && (
                    <div className="col-6">
                      <label className="form-label">Beneficiary Email Address</label>
                      <InputGroup className="mb-3">
                        <FormControl
                          type="email"
                          name="beneficiary_email"
                          placeholder="Beneficiary Email Address"
                          value={beneficiary.beneficiary_email}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                    </div>
                  )}
                  {beneficiary.notify_sms && (
                    <div className="col-6">
                      <label className="form-label">Beneficiary Phone Number</label>
                      <InputGroup className="mb-3">
                        <FormControl
                          name="beneficiary_cell"
                          placeholder="Beneficiary Phone Number"
                          value={beneficiary.beneficiary_cell}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                    </div>
                  )}
                </>
              )}

              <div className="col-12 mb-2 mt-2">
                <h6 className="text-muted text-uppercase small fw-bold border-bottom pb-1">
                  Bank Details
                </h6>
              </div>

              <div className="col-6">
                <label className="form-label">Bank Name</label>
                <InputGroup className="mb-3">
                  <FormControl
                    name="bank_name"
                    placeholder="Enter a bank name"
                    value={beneficiary.bank_name}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </div>

              <div className="col-6">
                <label className="form-label">Branch / Sort Code</label>
                <InputGroup className="mb-3">
                  <FormControl
                    name="bank_branch_code"
                    placeholder="Enter bank branch code"
                    type="number"
                    value={beneficiary.bank_branch_code}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </div>

              <div className="col-12">
                <label className="form-label">Bank Address</label>
                <InputGroup className="mb-3">
                  <FormControl
                    name="bank_address"
                    placeholder="Bank Address"
                    as="textarea"
                    rows={2}
                    value={beneficiary.bank_address}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </div>

              <div className="col-6">
                <label className="form-label">Bank Country</label>
                <Form.Control
                  as="select"
                  name="bank_country"
                  className="mb-3"
                  value={beneficiary.bank_country}
                  onChange={this.handleChange}
                >
                  <option value="">Select a country</option>
                  {countries.map((c) => (
                    <option key={c.id} value={c.name}>
                      {c.name}
                    </option>
                  ))}
                </Form.Control>
              </div>

              <div className="col-6">
                <label className="form-label">Currency</label>
                <Form.Control
                  as="select"
                  name="currency"
                  className="mb-3"
                  value={beneficiary.currency}
                  onChange={this.handleChange}
                >
                  <option value="">Select a currency</option>
                  {currencies.map((c) => (
                    <option key={c.alpha_3} value={c.alpha_3}>
                      {c.alpha_3} - {c.name}
                    </option>
                  ))}
                </Form.Control>
              </div>

              <div className="col-6">
                <label className="form-label">Account Number / IBAN*</label>
                <InputGroup className="mb-3">
                  <FormControl
                    name="beneficiary_account_number"
                    placeholder="Account Number"
                    value={beneficiary.beneficiary_account_number}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </div>

              <div className="col-6">
                <label className="form-label">Swift / BIC Code</label>
                <InputGroup className="mb-3">
                  <FormControl
                    name="swift_or_bic"
                    placeholder="Enter SWIFT or BIC code"
                    value={beneficiary.swift_or_bic}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </div>

              <div className="col-6">
                <label className="form-label">Default SWIFT Fees Instruction</label>
                <Form.Control
                  as="select"
                  className="mb-3"
                  value={beneficiary.swift_fees_instructions}
                  onChange={(e) =>
                    this.setState((st) => ({
                      beneficiary: {
                        ...st.beneficiary,
                        swift_fees_instructions: e.target.value,
                      },
                    }))
                  }
                >
                  <option value="">Select a Fee Instruction</option>
                  <option value="1">
                    All transaction charges are to be borne by the ordering customer.
                  </option>
                  <option value="2">
                    All transaction charges are to be split between ordering customer and beneficiary.
                  </option>
                  <option value="3">
                    All transaction charges are to be borne by the beneficiary customer.
                  </option>
                </Form.Control>
              </div>

              <div className="col-6">
                <label className="form-label">Is this a Crypto transaction?</label>
                <div className="mb-3">
                  <Form.Check
                    inline
                    type="radio"
                    label="Yes"
                    name="crypto"
                    checked={beneficiary.crypto === true}
                    onChange={() =>
                      this.setState((st) => ({
                        beneficiary: { ...st.beneficiary, crypto: true },
                      }))
                    }
                  />
                  <Form.Check
                    inline
                    type="radio"
                    label="No"
                    name="crypto"
                    checked={beneficiary.crypto === false}
                    onChange={() =>
                      this.setState((st) => ({
                        beneficiary: { ...st.beneficiary, crypto: false },
                      }))
                    }
                  />
                </div>
              </div>

            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => this.props.back()}>
              ← Back
            </Button>
            <Button
              variant="success"
              onClick={async () => {
                await this.formValidation();
                const { notify_email, notify_sms } = this.state.beneficiary;
                if (!notify_email && !notify_sms) {
                  alert("Please select a Proof of Payment method (Email, SMS, or both).");
                  return;
                }
                if (isNull(this.state.errorArray.find((d) => d === false)))
                  this.props.next(this.state.beneficiary);
              }}
            >
              Update Entity Beneficiary
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

EntityBeneficiaryEditForm.propTypes = {
  isShown: PropTypes.bool,
  close: PropTypes.func,
  back: PropTypes.func,
  next: PropTypes.func,
  beneficiary: PropTypes.object,
  client: PropTypes.object,
  countries: PropTypes.array,
  currencies: PropTypes.array,
};

export default EntityBeneficiaryEditForm;
